import { $Q } from '../utils/querySelector';
import Swiper, { Navigation, Autoplay, Pagination } from 'swiper';
import 'swiper/css';

class SliderSection {
  constructor() {
    this.sliderSection = $Q('#js-slider-section');

    this.sliderSection && this._init();
  }

  /**
   * Initialize slider section features
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _init() {
    this._swiperSliderInit();
  }

  /**
   * Initialize swiper slider
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _swiperSliderInit() {
    this.slide = new Swiper('.slider-section__slider', {
      modules: [Navigation, Autoplay, Pagination],
      slidesPerView: 1,
      spaceBetween: 8,
      loop: true,
      pagination: {
        el: '.swiper-slider-section-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: `.swiper-button-next.swiper-slider-section-button`,
        prevEl: `.swiper-button-prev.swiper-slider-section-button`,
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      breakpoints: {
        375: {
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 1,
          spaceBetween: 64,
        },
      },
    });
  }
}

export { SliderSection };
